/**
 * Emit hosts for the `context` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { SegmentActionName, SegmentObjectName } from '@heidi/analytics/events';

// context tab
export function contextAddContent(input: {
  sessionId: string;
  wordCount: number;
  userId: string;
}) {
  trackLegacyEvent({
    name: SegmentObjectName.Context,
    props: {
      action: SegmentActionName.ContextAddContent,
      sessionId: input.sessionId,
      wordCount: input.wordCount,
      userId: input.userId,
    },
  });

  // V2 — Amplitude migration (context text edits → context_updated)
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ContextUpdated,
    props: {
      session_id: input.sessionId,
      word_count: input.wordCount,
    },
  });
}
